import { render, staticRenderFns } from "./ViewClientRecordCategory.vue?vue&type=template&id=5e8da337&scoped=true"
import script from "./ViewClientRecordCategory.vue?vue&type=script&lang=js"
export * from "./ViewClientRecordCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8da337",
  null
  
)

export default component.exports